
import { Component, Prop } from "vue-property-decorator";
import { HcPageModel } from "@dev/hc-components";
import IBlock3Employee from "@/module/main/model/applicationForm/IBlock3Employee";
import HcAddress from "./HcAddress.vue";
import ContractDurationType from "@/module/main/dto/customer/ContractDurationTypeEnum";
import { EnumUtil } from "@/app";

@Component({
    components: {
        HcAddress,
    }
})
export default class Block3Employee extends HcPageModel {
    @Prop({type: Object}) public value!: IBlock3Employee;

    protected pageName: string = "block3-employee";

    private get contractDurationTypeData(): object[] {
        return EnumUtil.createSelectDataFromEnum(ContractDurationType, "ContractDurationType", true);
    }
    
    private get showContractDurationValidity(): boolean {
        return this.value.contractDurationType === ContractDurationType.FIXED_TERM;
    }
}
